export interface UserChatCrm {
    id: number;
    user: string;
    idRol:number;
    expirationDate: string;
    idCustomer: number;
    email:string;
    passwordRestore?: boolean;
}

export const inicializarChatCrm: UserChatCrm = {
    id: 0,
    user: '',
    idRol:0,
    expirationDate: '',
    email:'',
    passwordRestore: false,

    idCustomer: 0,
}

export interface MessageChat{
    chatId:string | undefined;
    idUser:number | null;
    user:string;
    message:string;
    idStatus:number | null;
    isImage?: boolean;
    isLocation?: boolean;
}
export interface NoteRequest{
    idUser:number;
    isCustomer:boolean;
    content:string;
    chatId:string | undefined;
    date?: string;
}

export interface ImageRequest{
    contentText?: string;
    urlFile?: string | null;
    isPdf?: boolean;
    chatId: string | undefined;
    user: string | undefined;
    idUser: number | undefined;
    idStatus: number | undefined
}

